<div class="xl-invoice" [ngClass]="rowCountIsEven?'invoice-commission-even': 'invoice-commission-odd'">
	<!--Sell Amount-->
	<div class="table-row">
		<span class="label">
			<ng-container *ngIf="payAmountTitle !==undefined">
				{{payAmountTitle | translate}}
			</ng-container>

			<ng-container *ngIf="payAmountTitle === undefined">
				{{'REQUEST.COMMISSION.SELL_AMOUNT' | translate}}
			</ng-container>
		</span>

		<span class="value">
			<div class="money-amount">
				{{ commission.requestedAmount | tcCurrency: commission.requestedPrecision }}</div>
			<div class="money-currency-code">
				{{commission.requestedCurrencyCode}}
			</div>
		</span>
	</div>

	<ng-container *ngIf="commission.commissionType !== commissionType.NONE">

		<!--Initial fee-->
		<div class="table-row">
			<span class="label">
				<ng-container *ngIf="commission.commissionType === commissionType.COMMISSION">
					{{'REQUEST.COMMISSION.INITIAL_COST' | translate}}
				</ng-container>

				<ng-container *ngIf="commission.commissionType === commissionType.BONUS">
					{{'REQUEST.COMMISSION.FIXED_AMOUNT' | translate}}
				</ng-container>

			</span>

			<span class="value">
				<div class="money-amount">
					{{commission.commissionInitialFee | tcCurrency: commission.requestedPrecision}}</div>
				<div class="money-currency-code">
					<ng-container *ngIf="commission.commissionInitialFee > 0">
						{{commission.requestedCurrencyCode}}
					</ng-container>
				</div>
			</span>
		</div>

		<!--comission-->

		<div class="table-row">
			<span class="label invoice-bonus">
				<span>
					<ng-container *ngIf="commission.commissionType === commissionType.COMMISSION">
						{{'REQUEST.COMMISSION.COMMISSION' | translate}}
					</ng-container>

					<ng-container *ngIf=" commission.commissionType === commissionType.BONUS">
						{{'REQUEST.COMMISSION.BONUS' | translate}}
					</ng-container>
					{{commission.commissionPercent}}%
				</span>
				<span class="data"
				*ngIf="(commission.minCommission > 0 || commission.maxCommission > 0) &&
                 commission.commissionAmount > 0 && (commission.commissionCalcType && commission.commissionCalcType !== commissionCalcType.CALCULATED)">

				<span class="red" *ngIf="commission.commissionCalcType === commissionCalcType.MINIMUM">
					<!--title-->
					<ng-container *ngIf="commission.commissionType === commissionType.COMMISSION">
						{{'REQUEST.COMMISSION.MINIMUM_COMMISION' | translate}}</ng-container>
					<ng-container *ngIf=" commission.commissionType === commissionType.BONUS">
						{{'REQUEST.COMMISSION.MINIMUM_BONUS' | translate}}</ng-container>
					<!--amount-->
					<span class="amount">
						<span class="number">
							{{commission.minCommission | tcCurrency: commission.requestedPrecision }}
						</span>
						<span class="currency">
							{{commission.requestedCurrencyCode}}
						</span>
					</span>
				</span>

				<span class="red" *ngIf="commission.commissionCalcType === commissionCalcType.MAXIMUM">
					<!--title-->
					<ng-container *ngIf=" commission.commissionType === commissionType.COMMISSION">
						{{'REQUEST.COMMISSION.MAXIMUM_COMMISION' | translate}}</ng-container>
					<ng-container *ngIf=" commission.commissionType === commissionType.BONUS">
						{{'REQUEST.COMMISSION.MAXIMUM_BONUS' | translate}}</ng-container>

					<span class="amount">
						<span class="number">
							{{commission.maxCommission | tcCurrency: commission.requestedPrecision}}
						</span>
						<span class="currency">
							{{commission.requestedCurrencyCode}}
						</span>
					</span>
				</span>
			</span>

			</span>

			<span class="value">
				<div class="money-amount">
					{{ commission.commissionAmount | tcCurrency: commission.requestedPrecision }}</div>
				<div class="money-currency-code">
					<span *ngIf="commission.commissionAmount > 0">
						{{ commission.requestedCurrencyCode }}
					</span>
				</div>
			</span>
		</div>


		<!--Calculated amount-->
		<div class="table-row">

			<span class="label">
				<!--*ngIf="requestType !== requestTypes.Send" -->
				<ng-container *ngIf="commission.commissionType === commissionType.COMMISSION">
					{{'REQUEST.COMMISSION.CALCULATED_AMOUNT' | translate}}
				</ng-container>

				<ng-container *ngIf=" commission.commissionType === commissionType.BONUS">
					{{'REQUEST.COMMISSION.CALCULATED_AMOUNT_BUNOS' | translate}}
				</ng-container>
			</span>
			<!-- 
            <span class="label" *ngIf="requestType === requestTypes.Send">
                {{ 'REQUEST.CALCULATED_AMOUNT_ALONE' | translate}}3333333333333333
            </span> -->

			<span class="value">
				<div class="money-amount">
					{{ commission.calculatedAmount | tcCurrency: commission.requestedPrecision }}</div>
				<div class="money-currency-code">
					{{commission.requestedCurrencyCode}}
				</div>
			</span>
		</div>
	</ng-container>

	<!--Exchange Rate-->
	<div class="table-row">
		<span class="label">
			{{'REQUEST.COMMISSION.EXCHANGE_RATE' | translate}}
		</span>

		<span class="value">
			<div class="money-amount">
				{{ commission.exchangeRate | tcCurrency: 10 }}</div>
			<div class="money-currency-code">
				<ng-container *ngIf="commission.exchangeRate !== 1">
					{{commission.exchangeCurrencyCode}}
				</ng-container>
			</div>
		</span>
	</div>

	<!--CONVERSION AMOUNT-->
	<div class="table-row" *ngIf="requestType === requestTypes.Send">
		<span class="label">
			{{'REQUEST.COMMISSION.GET_AMOUNT_THIRD_PARTY' | translate}}
		</span>

		<span class="value">
			<div class="money-amount">
				{{commission.convertedAmount | tcCurrency: commission.payOrGetPrecision }}</div>
			<div class="money-currency-code">
				{{ commission.payOrGetCurrencyCode }}
			</div>
		</span>
	</div>

	<!--Point-->
	<div class="table-row" *ngIf="commission.point">
		<span class="label">
			{{'REQUEST.COMMISSION.POINT' | translate}}
		</span>

		<span class="value">
			{{ commission.point | tcCurrency: pointPrecision }}
		</span>
	</div>

	<!-- Amount-->
	<div class="table-row">
		<span class="label">
			<ng-container *ngIf="getAmountTitle !== undefined">
				{{getAmountTitle | translate}}
			</ng-container>

			<ng-container *ngIf="getAmountTitle === undefined">
				{{'REQUEST.COMMISSION.CHARGE_AMOUNT' | translate}}
			</ng-container>
		</span>

		<span class="value" *ngIf="requestType !== requestTypes.Send">
			<span class="money-amount">
				{{ commission.payOrGetAmount | tcCurrency: commission.payOrGetPrecision }}
			</span>

			<span class="money-currency-code">
				{{ commission.payOrGetCurrencyCode }}
			</span>
		</span>


		<span class="value" *ngIf="requestType === requestTypes.Send">
			<span class="money-amount">
				{{ commission.calculatedAmount | tcCurrency: commission.requestedPrecision }}
			</span>
			<span class="money-currency-code">
				{{commission.requestedCurrencyCode}}
			</span>
		</span>
	</div>

</div>
